import styled, { css } from 'styled-components';

const Divider = styled.div`
  ${(props) => {
    const color = props.color || 'neutral-200';
    let margin = '0';
    let width = '100%';
    let height = '1px';
    let display = 'block';
    if (props.direction === 'vertical') {
      margin = '0 1rem';
      width = '1px';
      height = '100%';
      display = 'inline-block';
    }
    return css`
      background: var(--${color});
      margin: ${margin};
      height: ${height};
      width: ${width};
      display: ${display};
    `;
  }}
`;

export default Divider;
